module.exports = __webpack_public_path__ + "media/images/teacher2-dac9c6ad56e8899a32251493e363dce8.jpg";